import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { contacto } from '../data/site';
type Accion = 'llamada' | 'whatsapp';
type Tono = 'solido' | 'outline';
type Tamano = 'md' | 'lg';
interface IconCircleButtonProps {
  accion: Accion;
  /** 'outline' para fondos claros, como la sección de Magia Blanca. */
  tono?: Tono;
  tamano?: Tamano;
  className?: string;
}
const tamanos: Record<Tamano, {
  boton: string;
  icono: string;
}> = {
  md: {
    boton: 'h-14 w-14',
    icono: 'h-6 w-6'
  },
  lg: {
    boton: 'h-16 w-16',
    icono: 'h-7 w-7'
  }
};
export function IconCircleButton({
  accion,
  tono = 'solido',
  tamano = 'md',
  className = ''
}: IconCircleButtonProps) {
  const esWhatsApp = accion === 'whatsapp';
  const href = esWhatsApp ? contacto.whatsappHref : contacto.telefonoHref;
  const label = esWhatsApp ? `Escríbenos por WhatsApp al ${contacto.whatsapp}` : `Llámanos al ${contacto.telefono}`;
  const halo = esWhatsApp ? 'rgba(37, 211, 102, 0.75)' : 'rgba(42, 171, 226, 0.75)';
  const color = esWhatsApp ? {
    solido: 'bg-[#25D366] text-[#08301a] hover:bg-[#1fbb59] hover:shadow-[0_0_26px_rgba(37,211,102,0.7)] focus-visible:outline-[#25D366]',
    outline: 'border-2 border-[#1a9c4b] bg-white/70 text-[#12763a] hover:bg-[#25D366] hover:border-[#25D366] hover:text-[#08301a] hover:shadow-[0_0_26px_rgba(37,211,102,0.5)] focus-visible:outline-[#1a9c4b]'
  }[tono] : {
    solido: 'bg-[#2AABE2] text-white hover:bg-[#1d97cc] hover:shadow-[0_0_26px_rgba(42,171,226,0.7)] focus-visible:outline-[#2AABE2]',
    outline: 'border-2 border-[#1d8dbd] bg-white/70 text-[#15749e] hover:bg-[#2AABE2] hover:border-[#2AABE2] hover:text-white hover:shadow-[0_0_26px_rgba(42,171,226,0.5)] focus-visible:outline-[#2AABE2]'
  }[tono];
  return <a href={href} {...esWhatsApp ? {
    target: '_blank',
    rel: 'noreferrer noopener'
  } : {}} aria-label={label} title={label} style={{
    '--cta-glow': halo
  } as React.CSSProperties} className={`cta-beat relative inline-flex shrink-0 items-center justify-center rounded-full shadow-lg shadow-black/25 transition-[background-color,border-color,color,transform,box-shadow] duration-300 ease-out hover:scale-[1.05] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 motion-reduce:transition-none motion-reduce:hover:scale-100 ${tamanos[tamano].boton} ${color} ${className}`} data-id="element-76" data-mp="1lvdcy2zirabh">
      {esWhatsApp ? <WhatsAppIcon className={tamanos[tamano].icono} data-id="element-77" data-mp="1uuut99kxnh5v" /> : <PhoneIcon className={tamanos[tamano].icono} aria-hidden="true" data-id="element-78" data-mp="1g7t98zpg2cdk" />}
    </a>;
}